import React from "react";
import { Table } from "antd";
import type { ColumnsType } from "antd/lib/table";

export interface DescuentoDia {
  Dia: string;
  Antes: number;
  Descu: number;
}

interface Props {
  data: DescuentoDia[];
  loading?: boolean;
}

const columns: ColumnsType<DescuentoDia> = [
  {
    title: "Día",
    dataIndex: "Dia",
    key: "Dia",
  },
  {
    title: "Antes",
    dataIndex: "Antes",
    key: "Antes",
    // render: (value) => `$${Number(value).toFixed(2)}`,
    align: "right",
  },
  {
    title: "Descu",
    dataIndex: "Descu",
    key: "Descu",
    // render: (value) => `$${Number(value).toFixed(2)}`,
    align: "right",
  },
];

const DescuentoDiaTable: React.FC<Props> = ({ data, loading }: Props) => {
  return (
    <Table
      title={() => <div style={{ textAlign: "left" }}>Descuento x Día</div>}
      className='custom-table-visor'
      columns={columns}
      // scroll={{ x: 50, y: 130 }}
      dataSource={data}
      loading={loading}
      pagination={false}
      bordered
      size='small'
      style={{ width: "100%" }}
    />
  );
};

export default DescuentoDiaTable;
